import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/psx-frontend/psx-frontend/app/trade-journal/TradeJournalClient.tsx");
